class aToggleSwitch extends HTMLInputElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', () => {
            this.sendSubscriptionConsent(this.dataset.url);
        });
    }

    sendSubscriptionConsent(url) {
        const data = {
            fieldName: this.dataset.fieldName,
            isChecked: this.checked
        };
        if (url) {
            fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data)
            })
            .then((response) => {
                return response.json();
            })
            .then((responseData) => {
                if (responseData.redirectUrl) {
                    window.location.href = responseData.redirectUrl;
                }
            });
        }
    }
}

customElements.define('a-toggle-switch', aToggleSwitch, {
    extends: 'input'
});
